import MapClient from "./MapClient.view";

export default MapClient;
